
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Poitiers dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Poitiers certifiée Google Partner, accompagne les entreprises poitevines pour augmenter leur visibilité en ligne et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Poitiers dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Poitiers certifiée Google Partner, accompagne les entreprises poitevines pour augmenter leur visibilité en ligne et générer plus de prospects.",
        },
      ],
    };
  },
};
